import script from "./GodApeQuestMintedStats.vue?vue&type=script&setup=true&lang=js"
export * from "./GodApeQuestMintedStats.vue?vue&type=script&setup=true&lang=js"

import "./GodApeQuestMintedStats.vue?vue&type=style&index=0&id=7c32b6b0&lang=scss"

const __exports__ = script;

export default __exports__